import { render, staticRenderFns } from "./TiarcoChemicalMYearlyComparison.vue?vue&type=template&id=6f2bd39e"
import script from "./TiarcoChemicalMYearlyComparison.vue?vue&type=script&lang=ts"
export * from "./TiarcoChemicalMYearlyComparison.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports